import { Injectable } from '@angular/core';
import { RepositoryService, UnitOfWorkService } from '@mri/breeze-entity';
import { MetadataStore } from 'breeze-client';
import { DraftBookmark } from '../models';
import { draftBookmarkQueries } from './queries/draft-bookmark-queries';

@Injectable({ providedIn: 'root' })
export class DraftBookmarkRepositoryService extends RepositoryService<DraftBookmark> {
  constructor(uow: UnitOfWorkService, metadataStore: MetadataStore) {
    super(uow, metadataStore, draftBookmarkQueries.selectAll);
  }
}
